module.exports = __webpack_public_path__ + "img/pwa-notifications-mobile.2819ef64.png";